import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate  } from "react-router-dom";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import Maintenance from "../Maintenance";
import errorMessages from "../../common/errorMessages";
import { Accordion, Card, Spinner } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FRONT_URL } from "../../config/config";
import { Select } from "antd";
import {
  fetchMedicalSpecialityTypeList,
  fetchBranchList,
  fetchDivisionList,
  fetchSalesOfficeList,
  getAllocatedMR,
  getPersonInquiryList,
} from "./actions";

/*** 
@purpose : Functional component
@Parameter : {}
**/
function PersonCustomer() {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [maxHeight, setMaxHeight] = useState(500);
  const [activeEmployeeSearch, setActiveEmployeeSearch] =
    useState("esearch-box");
  const [showPersonData, setShowPersonData] = useState("card card-hide");
  const [showPersonDetails, setShowPersonDetails] = useState(false);
  const [maintenance, setMaintenance] = useState(false);
  const [allocatedSalesOfficeList, setAllocatedSalesOfficeList] = useState([]);
  const [hundredBedsList, setHundredBedsList] = useState([]);
  const [facilityClassList, setFacilityClassList] = useState([]);
  const [facilityFunctionList, setFacilityFunctionList] = useState([]);
  const [ultmarcRecordList, setUltmarcRecordList] = useState([]);
  const [customerTypeList, setCustomerTypeList] = useState([]);
  const [medicalSpecialitySuperTypeList, setMedicalSpecialitySuperTypeList] =
    useState("");
  const [medicalSpecialityTypeList, setMedicalSpecialityTypeList] =
    useState("");
  const [buList, setBuList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [salesOfficeList, setSalesOfficeList] = useState([]);
  const [mrList, setMRList] = useState([]);
  const [selectedMRList, setSelectedMRList] = useState([]);
  const [personList, setPersonList] = useState([]);
  const [universityList, setUniversityList] = useState([]);
  const [allocatedSalesOfficeID, setAllocatedSalesOfficeID] = useState("");
  const [hundredBedID, setHundredBedID] = useState("");
  const [customerTypeID, setCustomerTypeID] = useState("");
  const [ultmarcRecordID, setUltmarcRecordID] = useState("");
  const [facilityFunctionID, setFacilityFunctionID] = useState("");
  const [facilityClassID, setFacilityClassID] = useState("");
  const [medicalSpecialitySuperTypeID, setMedicalSpecialitySuperTypeID] =
    useState("");
  const [medicalSpecialitySuperTypeName, setMedicalSpecialitySuperTypeName] =
    useState("");
  const [medicalSpecialityTypeID, setMedicalSpecialityTypeID] = useState("");
  const [medicalSpecialityTypeName, setMedicalSpecialityTypeName] =
    useState("");
  const [buID, setBuID] = useState("");
  const [branchID, setBranchID] = useState("");
  const [divisionID, setDivisionID] = useState("");
  const [buValue, setBuValue] = useState("");
  const [branch, setBranch] = useState("");
  const [division, setDivision] = useState("");
  const [salesOffice, setSalesOffice] = useState("");
  const [universityID, setUniversityID] = useState("");
  const [salesOfficeID, setSalesOfficeID] = useState("");
  const [facilityKanjiName, setFacilityKanjiName] = useState("");
  const [facilityKanaName, setFacilityKanaName] = useState("");
  const [personKanjiName, setPersonKanjiName] = useState("");
  const [personKanaName, setPersonKanaName] = useState("");
  const [unifiedCustomerCode, setUnifiedCustomerCode] = useState("");
  const [wwid, setWWID] = useState("");
  const [name, setName] = useState("");
  const [limit, setLimit] = useState(40);
  const [graduatedYearFrom, setGraduatedYearFrom] = useState("");
  const [graduatedYearFromDate, setGraduatedYearFromDate] = useState();
  const [graduatedYearToDate, setGraduatedYearToDate] = useState();
  const [graduatedYearTo, setGraduatedYearTo] = useState("");
  const [allChecked, setAllChecked] = useState(false);
  const [sortValue, setSortValue] = useState("UnifiedCustomerCode");
  const [noData, setNoData] = useState(false);
  const [noEmployeeData, setNoEmployeeData] = useState(false);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState();
  const [errors, setErrors] = useState({});
  const [employeeErrors, setEmployeeErrors] = useState({});
  const [applyNotice, setApplyNotice] = useState(false);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [employeeDataLoading, setEmployeeDataLoading] = useState(false);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [divisionLoading, setDivisionLoading] = useState(false);
  const [branchLoading, setBranchLoading] = useState(false);
  const [salesOfficeLoading, setSalesOfficeLoading] = useState(false);
  const [specialityTwoLoading, setSpecialityTwoLoading] = useState(false);

  const [sortCode, setSortCode] = useState("asc");
  const [sortKanjiName, setSortKanjiName] = useState("asc");
  const [sortKanaName, setSortKanaName] = useState("asc");
  const [sortGender, setSortGender] = useState("asc");
  const [sortCustomerType, setSortCustomerType] = useState("asc");
  const [sortGraduatedUniversity, setSortGraduatedUniversity] = useState("asc");
  const [sortGraduatedYear, setSortGraduatedYear] = useState("asc");
  const [personLazyLoadData, setPersonLazyLoadData] = useState({});
  const [employeeLazyLoadData, setEmployeeLazyLoadData] = useState({});
  const [activeKey, setActiveKey] = useState("0");

  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.personCustomer")}`,
      path: "",
    },
  ];

  useEffect(() => {
    document.body.classList.add("sidebar-open");
    const allocatedSalesOffice = sessionStorage.getItem(
      "Allocated sales office"
    );
    const bu = sessionStorage.getItem("BU");
    const universityList = sessionStorage.getItem("University list");
    const personBedsList = sessionStorage.getItem("Person hundred beds list");
    const facClassList = sessionStorage.getItem("Person facility class list");
    const ultRecordList = sessionStorage.getItem("Person ultmarc record list");
    const custTypeList = sessionStorage.getItem("Person customer type");
    const facFunctionList = sessionStorage.getItem("Person facility function");
    const medicalSpecSuperTypeList = sessionStorage.getItem(
      "Person medical speciality super type list"
    );
    const personData = JSON.parse(sessionStorage.getItem("personData"));
    setAllocatedSalesOfficeList(JSON.parse(allocatedSalesOffice));
    setBuList(JSON.parse(bu));
    setUniversityList(JSON.parse(universityList));
    setHundredBedsList(JSON.parse(personBedsList));
    setFacilityClassList(JSON.parse(facClassList));
    setUltmarcRecordList(JSON.parse(ultRecordList));
    setCustomerTypeList(JSON.parse(custTypeList));
    setFacilityFunctionList(JSON.parse(facFunctionList));
    setMedicalSpecialitySuperTypeList(JSON.parse(medicalSpecSuperTypeList));

    // if (personData && Object.keys(personData).length > 0) {
    //   console.log("session", JSON.parse(sessionStorage.getItem("personData")));
    //   await getPersonInquiryList(
    //     JSON.parse(sessionStorage.getItem("personData"))
    //   ).then((response) => {
    //     if (response.maintenanceWindowFlag) {
    //       setMaintenance(true);
    //     } else {
    //       if (
    //         (response.success === true && response.data.length === 0) ||
    //         response.success === false
    //       ) {
    //         setIsLoading(false);
    //         setLoading(false);
    //         setNoData(true);
    //         setPersonList([]);
    //       }
    //       if (response.success === true && response.data.length > 0) {
    //         setIsLoading(false);
    //         setLoading(false);
    //         let id = "";
    //         let name = "";
    //         var result =
    //           response &&
    //           response.data.map(function (el) {
    //             var o = Object.assign({}, el);
    //             id = o && o.genderNameLocal && o.genderNameLocal.key;
    //             o.genderId = id;
    //             name = o && o.genderNameLocal && o.genderNameLocal.value;
    //             o.genderName = name ? name : "";
    //             return o;
    //           });
    //         setActiveKey("1");
    //         setPersonList(result);
    //         setTotal(response && response.data[0].total);
    //         console.log(
    //           typeof total,
    //           "total",
    //           response.data[0].total,
    //           typeof response.data[0].total
    //         );
    //         setNoData(false);
    //       }
    //     }
    //   });
    // }
  }, []);

  // useEffect(() => {
  //   let payload = {
  //     personNameKanji: personKanjiName,
  //     personNameKana: personKanaName,
  //     facilityNameKanji: facilityKanjiName,
  //     facilityNameKana: facilityKanaName,
  //     unifiedCustomerCode: unifiedCustomerCode,
  //     medicalSpecialityOneID: medicalSpecialitySuperTypeID,
  //     medicalSpecialityTwoID: medicalSpecialityTypeID,
  //     allocatedSalesOfficeID: allocatedSalesOfficeID,
  //     empID: list,
  //     custTypeID: customerTypeID,
  //     ultmarcRecordID: ultmarcRecordID,
  //     hundredBedsType: hundredBedID,
  //     facilityFunctionType: facilityFunctionID,
  //     facilityClassType: facilityClassID,
  //     uniID: universityID,
  //     gradutedYearFrom: graduatedYearFrom,
  //     gradutedYearTo: graduatedYearTo,
  //     limit: personList.length,
  //     totalRecords: total,
  //   };
  //   console.log("inside", payload);
  //   return () => {
  //     sessionStorage.setItem("personData", JSON.stringify(payload));
  //   };
  // }, []);

  const handleEmployeeContainerOnBottom = () => {
    if (mrList.length > 0) {
      setLazyLoading(true);
      let body = {
        buID: employeeLazyLoadData.buID,
        divisionID: employeeLazyLoadData.divisionID,
        branchID: employeeLazyLoadData.branchID,
        salesOfficeID: employeeLazyLoadData.salesOfficeID,
        wwid: employeeLazyLoadData.wwid,
        mrName: employeeLazyLoadData.mrName,
      };
      setLazyLoading(false);
      if (mrList.length <= totalEmployees) {
        getAllocatedMR(body).then((response) => {
          if (response !== null) {
            var result =
              response &&
              response.map(function (el) {
                var o = Object.assign({}, el);
                o.isChecked = false;
                return o;
              });
            let list = [];
            list = mrList.concat(result);
            setMRList(list);
            setEmployeeLoading(false);
          } else {
            setMRList(mrList);
          }
        });
        setLimit(limit + 10);
      }
    }
  };

  /*** 
  @purpose : Open employee search
  @Parameter : {}
  **/
  const openEmployeeSearch = () => {
    setActiveEmployeeSearch(
      activeEmployeeSearch === "esearch-box"
        ? "esearch-box active"
        : "esearch-box"
    );
  };

  /*** 
  @purpose : Add employee search
  @Parameter : {}
  **/
  const addEmployeeSearch = () => {
    let selected = [];
    mrList.map((mr) => {
      if (mr.isChecked == true) {
        selected.push(mr);
      }
    });
    let id = [];
    let name = [];
    selected.map((s) => id.push(s.wwid));
    selected.map((s) => name.push(s.mrName));
    setSelectedMRList(selected);
    setActiveEmployeeSearch(
      activeEmployeeSearch === "esearch-box"
        ? "esearch-box active"
        : "esearch-box"
    );
  };

  /*** 
  @purpose : Handle sort order
  @Parameter : {e}
  **/
  const handleSortOrder = (e) => {
    setSortValue(e.target.value);
  };

  /*** 
  @purpose : Handle university change
  @Parameter : {value}
  **/
  const handleUniversityChange = (value) => {
    if (value) {
      const id = value.value;
      setUniversityID(id);
    } else {
      setUniversityID("");
    }
  };

  /*** 
  @purpose : validate employee form
  @Parameter : {}
  **/
  const validateEmployeeForm = () => {
    let isFormValid = true;
    setApplyNotice(false);
    let pattern = new RegExp(/[<.|\n*?>]/);
    let regex = new RegExp(
      /[一-龠]+|[ぁ-ゔ]+|[ァ-ヴー]+|[a-zA-Z0-9]+|[ａ-ｚＡ-Ｚ０-９]+[々〆〤]+/
    );
    let errors = {
      name: "",
    };

    if (name && !regex.test(name)) errors.name = errorMessages.VALID_NAME;
    else if (name && pattern.test(name)) errors.name = errorMessages.VALID_NAME;
    else errors.name = "";

    if (errors.name !== "") {
      isFormValid = false;
    } else if (
      buID === "" &&
      divisionID === "" &&
      branchID === "" &&
      salesOfficeID === "" &&
      wwid === "" &&
      name === ""
    ) {
      isFormValid = false;
      setApplyNotice(true); 
    } else {
      isFormValid = true;
    }

    setEmployeeErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle employee search
  @Parameter : {}
  **/
  const handleEmployeeSearch = () => {
    if (validateEmployeeForm()) {
      setEmployeeDataLoading(true);
      setNoEmployeeData(false);
      const body = {
        buID: buID,
        divisionID: divisionID,
        branchID: branchID,
        salesOfficeID: salesOfficeID,
        wwid: wwid,
        mrName: name,
      };
      setEmployeeLazyLoadData(body);
      getAllocatedMR(body).then((response) => {
        setEmployeeDataLoading(false);
        if (response.success === true && response.data.length > 0) {
          var result =
            response &&
            response.data.map(function (el) {
              var o = Object.assign({}, el);
              o.isChecked = false;
              return o;
            });
          setMRList(result);
          setNoEmployeeData(false);
        }
        if (
          (response.success === true && response.data.length === 0) ||
          response.success === false
        ) {
          setLoading(false);
          setNoEmployeeData(true);
          setMRList([]);
        }
      });
    }
  };

  const loadRecords = () => {
    let body = {
      personNameKanji: personLazyLoadData.personNameKanji,
      personNameKana: personLazyLoadData.personKanaName,
      facilityNameKanji: personLazyLoadData.facilityKanjiName,
      facilityNameKana: personLazyLoadData.facilityKanaName,
      unifiedCustomerCode: personLazyLoadData.unifiedCustomerCode,
      medicalSpecialityOneID: personLazyLoadData.medicalSpecialityOneID,
      medicalSpecialityTwoID: personLazyLoadData.medicalSpecialityTwoID,
      allocatedSalesOfficeID: personLazyLoadData.allocatedSalesOfficeID,
      empID: personLazyLoadData.empID,
      custTypeID: personLazyLoadData.custTypeID,
      ultmarcRecordID: personLazyLoadData.ultmarcRecordID,
      hundredBedsType: personLazyLoadData.hundredBedsType,
      facilityFunctionType: personLazyLoadData.facilityFunctionType,
      facility_class_type: personLazyLoadData.facility_class_type,
      uniID: personLazyLoadData.uniID,
      gradutedYearFrom: personLazyLoadData.graduatedYearFrom,
      gradutedYearTo: personLazyLoadData.graduatedYearTo,
      limit: personList.length,
      totalRecords: total,
    };
    if (personList.length < total) {
      setLazyLoading(true);
      getPersonInquiryList(body).then((response) => {
        let list = [];
        let id = "";
        let name = "";
        var result =
          response &&
          response.data.map(function (el) {
            var o = Object.assign({}, el);
            id = o.genderNameLocal.key;
            o.genderId = id;
            name = o.genderNameLocal.value;
            o.genderName = name;
            return o;
          });
        list = personList.concat(result);
        setLazyLoading(false);
        setPersonList(list);
      });
      setLimit(limit + 10);
    }
  };

  // const handleContainerOnBottom = useCallback(async () => {
  //   console.log("called", personList.length, total);
  //   let body = {
  //     personNameKanji: personLazyLoadData.personNameKanji,
  //     personNameKana: personLazyLoadData.personKanaName,
  //     facilityNameKanji: personLazyLoadData.facilityKanjiName,
  //     facilityNameKana: personLazyLoadData.facilityKanaName,
  //     unifiedCustomerCode: personLazyLoadData.unifiedCustomerCode,
  //     medicalSpecialityOneID: personLazyLoadData.medicalSpecialityOneID,
  //     medicalSpecialityTwoID: personLazyLoadData.medicalSpecialityTwoID,
  //     allocatedSalesOfficeID: personLazyLoadData.allocatedSalesOfficeID,
  //     empID: personLazyLoadData.empID,
  //     custTypeID: personLazyLoadData.custTypeID,
  //     ultmarcRecordID: personLazyLoadData.ultmarcRecordID,
  //     hundredBedsType: personLazyLoadData.hundredBedsType,
  //     facilityFunctionType: personLazyLoadData.facilityFunctionType,
  //     facility_class_type: personLazyLoadData.facility_class_type,
  //     uniID: personLazyLoadData.uniID,
  //     gradutedYearFrom: personLazyLoadData.graduatedYearFrom,
  //     gradutedYearTo: personLazyLoadData.graduatedYearTo,
  //     limit: personList.length,
  //     totalRecords: total,
  //   };
  //   // sessionStorage.setItem("personData", JSON.stringify(body));
  //   if (personList.length <= total && total >= 30) {
  //     await getPersonInquiryList(body).then((response) => {
  //       let list = [];
  //       let id = "";
  //       let name = "";
  //       var result =
  //         response &&
  //         response.data.map(function (el) {
  //           var o = Object.assign({}, el);
  //           id = o.genderNameLocal.key;
  //           o.genderId = id;
  //           name = o.genderNameLocal.value;
  //           o.genderName = name;
  //           return o;
  //         });
  //       list = personList.concat(result);
  //       setPersonList(list);
  //     });
  //     setLimit(limit + 10);
  //   }
  // }, [personList, limit, total]);

  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  const employeeContainerRef = useBottomScrollListener(
    handleEmployeeContainerOnBottom
  );

  /*** 
  @purpose : Validate form
  @Parameter : {}
  **/
  const validateForm = () => {
    let isFormValid = true;
    let pattern = new RegExp(/[<.|\n*?>]/);
    let kanaRegex = new RegExp(/^[ｦ-ﾟ -~]+$/);
    let errors = {
      personNameKanji: "",
      personNameKana: "",
      facilityKanjiName: "",
      facilityKanaName: "",
    };

    if (personKanjiName && pattern.test(personKanjiName))
      errors.personKanjiName = "errorMessages.VALID_KANJI_PERSON_NAME";
    else errors.personKanjiName = "";

    if (personKanaName && kanaRegex.test(personKanaName) === false)
      errors.personKanaName = "errorMessages.VALID_KANA_PERSON_NAME";
    else errors.personKanaName = "";

    if (facilityKanjiName && pattern.test(facilityKanjiName))
      errors.facilityKanjiName = "errorMessages.VALID_KANJI_FACILITY_NAME";
    else errors.facilityKanjiName = "";

    if (facilityKanaName && kanaRegex.test(facilityKanaName) === false)
      errors.facilityKanaName = "errorMessages.VALID_KANA_FACILITY_NAME";
    else errors.facilityKanaName = "";

    if (
      errors.personKanjiName !== "" ||
      errors.personKanaName ||
      errors.facilityKanjiName !== "" ||
      errors.facilityKanaName
    ) {
      isFormValid = false;
    } else {
      isFormValid = true;
    }

    setErrors(errors);
    return isFormValid;
  };

  /*** 
  @purpose : Handle person search
  @Parameter : {}
  **/
  const handlePersonSearch = () => {
    const trimmedPersonKanjiName = personKanjiName.trim();
    const trimmedPersonKanaName = personKanaName.trim();
    if (validateForm()) {
      setIsLoading(true);
      setShowPersonData("card card-show");
      setLoading(true);
      setNoData(false);
      let list = [];
      selectedMRList.map((mr) => list.push(mr.wwid));
      let body = {
        personNameKanji: trimmedPersonKanjiName,
        personNameKana: trimmedPersonKanaName,
        facilityNameKanji: facilityKanjiName,
        facilityNameKana: facilityKanaName,
        unifiedCustomerCode: unifiedCustomerCode,
        medicalSpecialityOneID: medicalSpecialitySuperTypeID,
        medicalSpecialityTwoID: medicalSpecialityTypeID,
        allocatedSalesOfficeID: allocatedSalesOfficeID,
        empID: list,
        custTypeID: customerTypeID,
        ultmarcRecordID: ultmarcRecordID,
        hundredBedsType: hundredBedID,
        facilityFunctionType: facilityFunctionID,
        facilityClassType: facilityClassID,
        uniID: universityID,
        gradutedYearFrom: graduatedYearFrom,
        gradutedYearTo: graduatedYearTo,
        limit: 0,
        totalRecords: 0,
      };
      // sessionStorage.setItem("personData", JSON.stringify(body));
      setPersonLazyLoadData(body);
      getPersonInquiryList(body).then((response) => {
        if (response.maintenanceWindowFlag) {
          setMaintenance(true);
        } else {
          if (
            (response.success === true && response.data.length === 0) ||
            response.success === false
          ) {
            setIsLoading(false);
            setLoading(false);
            setNoData(true);
            setPersonList([]);
          }
          if (response.success === true && response.data.length > 0) {
            setIsLoading(false);
            setLoading(false);
            let id = "";
            let name = "";
            var result =
              response &&
              response.data.map(function (el) {
                var o = Object.assign({}, el);
                id = o && o.genderNameLocal && o.genderNameLocal.key;
                o.genderId = id;
                name = o && o.genderNameLocal && o.genderNameLocal.value;
                o.genderName = name ? name : "";
                return o;
              });
            setPersonList(result);
            setTotal(response && response.data[0].total);
            setNoData(false);
          }
        }
      });
    }
  };

  /*** 
  @purpose : Reset person inquiry form
  @Parameter : {}
  **/
  const resetPersonInquiryForm = () => {
    setPersonKanjiName("");
    setPersonKanaName("");
    setFacilityKanjiName("");
    setFacilityKanaName("");
    setUnifiedCustomerCode("");
    setGraduatedYearFrom("");
    setGraduatedYearTo("");
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleEmployeeSort = (col) => {
    let list = [...mrList];
    list.sort((a, b) => {
      if (`a.${col}` < `b.${col}`) {
        return -1;
      }
      if (`a.${col}` > `b.${col}`) {
        return 1;
      }
      return 0;
    });
    setMRList(list);
  };

  /*** 
  @purpose : Handle sorting
  @Parameter : {}
  **/
  const handleSortingData = (obj) => {
    /* obj.column === "legacyUnifiedCustomerCode" && setSortCode(obj.sortOrder); /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "unifiedCustomerCode" && setSortCode(obj.sortOrder);          /* SAKAMOTO: AHDD-5861 Ultmarc code change */
    obj.column === "customerNameLocal" && setSortKanjiName(obj.sortOrder);
    obj.column === "customerNameLocalKana" && setSortKanaName(obj.sortOrder);
    obj.column === "genderName" && setSortGender(obj.sortOrder);
    obj.column === "customerTypeNameLocal" &&
      setSortCustomerType(obj.sortOrder);
    obj.column === "universityNameLocal" &&
      setSortGraduatedUniversity(obj.sortOrder);
    obj.column === "graduatedYear" && setSortGraduatedYear(obj.sortOrder);
    let list = compareBySortedData(obj);
    setPersonList(list);
  };

  const compareBySortedData = (obj) => {
    const sorted = personList.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };

  /*** 
  @purpose : Handle person details
  @Parameter : {id}
  **/
  const handlePersonDetails = (id) => {
    setShowPersonDetails(true);
    // navigate(`/personInfo?personId=${id}`);
    window.open(FRONT_URL + `/personInfo?personId=${id}`, "_blank");
  };

  /*** 
  @purpose : Handle medical speciality type 1 change
  @Parameter : {value}
  **/
  const handleMedicalSpecialityType1Change = async (value) => {
    if (value) {
      setSpecialityTwoLoading(true);
      let id = value.value;
      setMedicalSpecialitySuperTypeID(id);
      setMedicalSpecialitySuperTypeName(value.label);
      await fetchMedicalSpecialityTypeList(id).then((res) => {
        setSpecialityTwoLoading(false);
        let newList = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.medicalSpecialityTwoID,
            label: item.medicalSpecialityNameLocalTwo,
          });
        }
        setMedicalSpecialityTypeList(newList);
      });
    } else {
      setSpecialityTwoLoading(false);
      setMedicalSpecialitySuperTypeID("");
      setMedicalSpecialitySuperTypeName("");
      setMedicalSpecialityTypeID("");
      setMedicalSpecialityTypeName("");
    }
  };

  /*** 
  @purpose : Handle medical speciality type 2 change
  @Parameter : {value}
  **/
  const handleMedicalSpecialityType2Change = async (value) => {
    if (value) {
      const id = value.value;
      setMedicalSpecialityTypeID(id);
      setMedicalSpecialityTypeName(value.label);
    } else {
      setMedicalSpecialityTypeID("");
      setMedicalSpecialityTypeID("");
    }
  };

  /*** 
  @purpose : Handle allocated sales office change
  @Parameter : {value}
  **/
  const handleAllocatedSalesOfficeChange = (value) => {
    if (value) {
      const id = value.value;
      setAllocatedSalesOfficeID(id);
    } else {
      setAllocatedSalesOfficeID("");
    }
  };

  /*** 
  @purpose : Handle BU change
  @Parameter : {value}
  **/
  const handleBUChange = async (value) => {
    setDivisionID("");
    setDivision("");
    setBranchID("");
    setBranch("");
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setDivisionLoading(true);
      let id = value.value;
      setBuID(id);
      setBuValue(value.label);
      await fetchDivisionList(id).then((res) => {
        setDivisionLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.divisionID, label: item.orgName });
        }
        setDivisionList(list);
      });
    } else {
      setDivisionLoading(false);
      setBuID("");
      setBuValue("");
      setDivisionID("");
      setDivision("");
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setDivisionList([]);
    }
  };

  /*** 
  @purpose : Handle division change
  @Parameter : {value}
  **/
  const handleDivisionChange = async (value) => {
    setBranchID("");
    setBranch("");
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setBranchLoading(true);
      let id = value.value;
      setDivisionID(id);
      setDivision(value.label);
      await fetchBranchList({ buID: buID, divisionID: id }).then((res) => {
        setBranchLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.branchID, label: item.orgName });
        }
        setBranchList(list);
      });
    } else {
      setBranchLoading(false);
      setDivisionID("");
      setDivision("");
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setDivisionList([]);
      setBranchList([]);
      setSalesOfficeList([]);
    }
  };

  /*** 
  @purpose : Handle branch change
  @Parameter : {value}
  **/
  const handleBranchChange = async (value) => {
    setSalesOfficeID("");
    setSalesOffice("");
    if (value) {
      setSalesOfficeLoading(true);
      let id = value.value;
      setBranchID(id);
      setBranch(value.label);
      await fetchSalesOfficeList({
        buID: buID,
        divisionID: divisionID,
        branchID: id,
      }).then((res) => {
        setSalesOfficeLoading(false);
        let list = [];
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          list.push({ value: item.salesOfficeID, label: item.orgName });
        }
        setSalesOfficeList(list);
      });
    } else {
      setSalesOfficeLoading(false);
      setBranchID("");
      setBranch("");
      setSalesOfficeID("");
      setSalesOffice("");
      setSalesOfficeList([]);
    }
  };

  /*** 
  @purpose : Handle sales office change
  @Parameter : {value}
  **/
  const handleSalesOfficeChange = async (value) => {
    if (value) {
      setSalesOffice(value.label);
      setSalesOfficeID(value.value);
    } else {
      setSalesOffice("");
      setSalesOfficeID("");
    }
  };

  /*** 
  @purpose : Hande checkbox
  @Parameter : {e}
  **/
  const handleCheckbox = (e) => {
    let tempListing = [...mrList];
    let checkedAll = allChecked;

    if (e.target.value === "checkAll") {
      tempListing.forEach((item) => {
        item.isChecked = e.target.checked;
        checkedAll = e.target.checked;
      });
    } else if (e.target.value !== "checkAll") {
      tempListing.forEach((item) => {
        if (item.wwid == e.target.value) {
          item.isChecked = e.target.checked;
        }
      });
    }
    setMRList(tempListing);
    setAllChecked(checkedAll);
  };

  /*** 
  @purpose : Handle bed change
  @Parameter : {value}
  **/
  const handleBedChange = async (value) => {
    if (value) {
      const id = value.value;
      setHundredBedID(id);
    } else {
      setHundredBedID("");
    }
  };

  /*** 
  @purpose : Handle customer type change
  @Parameter : {value}
  **/
  const handleCustomerTypeChange = async (value) => {
    if (value) {
      const id = value.value;
      setCustomerTypeID(id);
    } else {
      setCustomerTypeID("");
    }
  };

  /*** 
  @purpose : Handle ultmarc record change
  @Parameter : {value}
  **/
  const handleUltmarcRecordChange = async (value) => {
    if (value) {
      const id = value.value;
      setUltmarcRecordID(id);
    } else {
      setUltmarcRecordID("");
    }
  };

  /*** 
  @purpose : Handle facility function change
  @Parameter : {value}
  **/
  const handleFacilityFunctionChange = async (value) => {
    if (value) {
      const id = value.value;
      setFacilityFunctionID(id);
    } else {
      setFacilityFunctionID("");
    }
  };

  /*** 
  @purpose : Handle facility class change
  @Parameter : {value}
  **/
  const handleFacilityClassChange = async (value) => {
    if (value) {
      const id = value.value;
      setFacilityClassID(id);
    } else {
      setFacilityClassID("");
    }
  };

  /*** 
  @purpose : Handle graduated year from
  @Parameter : {date}
  **/
  const handleGraduatedYearFrom = (date) => {
    setGraduatedYearFromDate(date);
    var date = new Date(date);
    setGraduatedYearFrom(date.getFullYear().toString());
  };

  /*** 
  @purpose : Handle graduated year to
  @Parameter : {date}
  **/
  const handleGraduatedYearTo = (date) => {
    setGraduatedYearToDate(date);
    var date = new Date(date);
    setGraduatedYearTo(date.getFullYear().toString());
  };

  /*** 
  @purpose : Remove employee
  @Parameter : {emp}
  **/
  const removeEmployee = (emp) => {
    let list = selectedMRList.filter((s) => s !== emp);
    setSelectedMRList(list);
  };

  
  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "customerinquiry";
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    const filteredTexts2 = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return (
    <Home>
      {maintenance ? (
        <Maintenance />
      ) : (
        <>
          <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
          <h2>{lang("Menu.personCustomer")}</h2>

          <Accordion defaultActiveKey={activeKey}>
            <Accordion.Item eventKey={activeKey}>
              <Accordion.Header>
                {lang("PersonMenu.personCustomerSearch")}
              </Accordion.Header>
              <Accordion.Body>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.kanjiPersonName")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={personKanjiName}
                            onChange={(e) => {
                              setPersonKanjiName(e.target.value);
                            }}
                          />
                          {errors.personKanjiName && (
                            <p className="error-text">
                              {lang(`${errors.personKanjiName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.kanaPersonName")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={personKanaName}
                            maxLength="100"
                            onChange={(e) =>
                              setPersonKanaName(e.target.value)
                            }
                          />
                          {errors.personKanaName && (
                            <p className="error-text">
                              {lang(`${errors.personKanaName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>
                      {lang("OrganizationMenu.kanjiFacilityName")}
                    </label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={facilityKanjiName}
                            maxLength="100"
                            onChange={(e) =>
                              setFacilityKanjiName(e.target.value)
                            }
                          />
                          {errors.facilityKanjiName && (
                            <p className="error-text">
                              {lang(`${errors.facilityKanjiName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>{lang("OrganizationMenu.kanaFacilityName")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={facilityKanaName}
                            maxLength="100"
                            onChange={(e) =>
                              setFacilityKanaName(e.target.value)
                            }
                          />
                          {errors.facilityKanaName && (
                            <p className="error-text">
                              {lang(`${errors.facilityKanaName}`)}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>
                      {lang("organizationDetails.unifiedCustomerCode")}
                    </label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            value={unifiedCustomerCode}
                            maxLength="10"
                            onChange={(e) =>
                              setUnifiedCustomerCode(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="horizon-form">
                  <div className="custom-3">
                    <label>{lang("PersonMenu.speciality")}</label>
                  </div>
                  <div className="custom-9">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            className="ant-select"
                            options={medicalSpecialitySuperTypeList}
                            placeholder={lang(
                              "errorMessages.medicalSpecialityOne"
                            )}
                            allowClear={
                              medicalSpecialitySuperTypeID ? true : false
                            }
                            showSearch={
                              medicalSpecialitySuperTypeList &&
                              medicalSpecialitySuperTypeList.length > 0
                                ? true
                                : false
                            }
                            onChange={handleMedicalSpecialityType1Change}
                            labelInValue
                            optionFilterProp="label"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            className="ant-select"
                            options={medicalSpecialityTypeList}
                            placeholder="(Medical Speciality Type(level 2))"
                            value={medicalSpecialityTypeID ? {
                              value: medicalSpecialityTypeID,
                              label: medicalSpecialityTypeName,
                            } : undefined}
                            allowClear={
                              medicalSpecialityTypeID ? true : false
                            }
                            loading={specialityTwoLoading}
                            showSearch={
                              medicalSpecialityTypeList &&
                              medicalSpecialityTypeList.length > 0
                                ? true
                                : false
                            }
                            disabled={medicalSpecialitySuperTypeID === ""}
                            onChange={handleMedicalSpecialityType2Change}
                            labelInValue
                            optionFilterProp="label"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      {lang("OrganizationMenu.moreConditions")}
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang(
                                "OrganizationMenu.allocatedSalesOffice"
                            )}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={allocatedSalesOfficeList}
                                    placeholder={lang(
                                        "OrganizationMenu.allocatedSalesOffice"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      allocatedSalesOfficeList &&
                                      allocatedSalesOfficeList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={
                                      handleAllocatedSalesOfficeChange
                                    }
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang("OrganizationMenu.allocatedMR")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="mrs-main">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="mrs-box">
                                  {/* <label className="select-mrs">(Multiple select MRs)</label> */}
                                  <ul className="selected-mrs">
                                    {selectedMRList &&
                                        selectedMRList.map((emp) => {
                                          return (
                                              <li key={emp.wwid}>
                                                {emp.mrName}
                                                <em
                                                    className="bx bx-x"
                                                    onClick={() =>
                                                        removeEmployee(emp)
                                                    }
                                                ></em>
                                              </li>
                                          );
                                        })}
                                  </ul>
                                  <button
                                      className="btn btn-primary"
                                      onClick={openEmployeeSearch}
                                  >
                                    {lang("Buttons.select")}
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div className={activeEmployeeSearch}>
                              <h3>
                                {lang(
                                    "organizationDetails.employeeSearch"
                                )}
                              </h3>
                              <div className="row">
                                <div className="col-xl-3 col-md-6">
                                  <div className="form-group">
                                    <label>
                                      {lang(
                                          "territoryDefinitionMaintenance.BU"
                                      )}
                                    </label>
                                    <Select
                                        className="ant-select"
                                        options={buList}
                                        onChange={handleBUChange}
                                        placeholder={lang(
                                            "territoryDefinitionMaintenance.BU"
                                        )}
                                        value={{
                                          value: buID,
                                          label: buValue,
                                        }}
                                        allowClear={buID ? true : false}
                                        showSearch={
                                          buList && buList.length > 0
                                              ? true
                                              : false
                                        }
                                        labelInValue
                                        optionFilterProp="label"
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-3 col-md-6">
                                  <div className="form-group">
                                    <label>
                                      {lang(
                                          "territoryDefinitionMaintenance.division"
                                      )}
                                    </label>
                                    <Select
                                        className="ant-select"
                                        options={divisionList}
                                        placeholder={lang(
                                            "territoryDefinitionMaintenance.division"
                                        )}
                                        value={{
                                          value: divisionID,
                                          label: division,
                                        }}
                                        showSearch={
                                          divisionList &&
                                          divisionList.length > 0
                                              ? true
                                              : false
                                        }
                                        disabled={
                                          buID === "" ? true : false
                                        }
                                        loading={divisionLoading}
                                        allowClear={
                                          divisionID ? true : false
                                        }
                                        onChange={handleDivisionChange}
                                        labelInValue
                                        optionFilterProp="label"
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-3 col-md-6">
                                  <div className="form-group">
                                    <label>
                                      {lang(
                                          "territoryDefinitionMaintenance.branch"
                                      )}
                                    </label>
                                    <Select
                                        className="ant-select"
                                        options={branchList}
                                        placeholder={lang(
                                            "territoryDefinitionMaintenance.branch"
                                        )}
                                        value={{
                                          value: branchID,
                                          label: branch,
                                        }}
                                        showSearch={
                                          branchList &&
                                          branchList.length > 0
                                              ? true
                                              : false
                                        }
                                        disabled={
                                          divisionID === "" ? true : false
                                        }
                                        loading={branchLoading}
                                        allowClear={
                                          branchID ? true : false
                                        }
                                        onChange={handleBranchChange}
                                        labelInValue
                                        optionFilterProp="label"
                                    />
                                  </div>
                                </div>
                                <div className="col-xl-3 col-md-6">
                                  <div className="form-group">
                                    <label>
                                      {lang(
                                          "territoryDefinitionMaintenance.salesOffice"
                                      )}
                                    </label>
                                    <Select
                                        className="ant-select"
                                        options={salesOfficeList}
                                        placeholder={lang(
                                            "territoryDefinitionMaintenance.salesOffice"
                                        )}
                                        value={{
                                          value: salesOfficeID,
                                          label: salesOffice,
                                        }}
                                        showSearch={
                                          salesOfficeList &&
                                          salesOfficeList.length > 0
                                              ? true
                                              : false
                                        }
                                        disabled={
                                          branchID === "" ? true : false
                                        }
                                        loading={salesOfficeLoading}
                                        allowClear={
                                          salesOfficeID ? true : false
                                        }
                                        onChange={handleSalesOfficeChange}
                                        labelInValue
                                        optionFilterProp="label"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group inline-input">
                                    <label>
                                      {lang(
                                          "territoryDefinitionMaintenance.wwid"
                                      )}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={wwid}
                                        onChange={(e) =>
                                            setWWID(e.target.value)
                                        }
                                    />
                                  </div>
                                </div>
                                <div className="clearfix"></div>
                                <div className="col-md-6">
                                  <div className="form-group inline-input">
                                    <label>
                                      {lang(
                                          "parentChildFacilityMaintenance.name"
                                      )}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={name}
                                        onChange={(e) =>
                                            setName(e.target.value)
                                        }
                                    />
                                    <p className="error-text">
                                      {employeeErrors.name}
                                    </p>
                                  </div>
                                </div>
                                <div className="col-12 mb-4">
                                  <button
                                      className="btn btn-primary"
                                      onClick={handleEmployeeSearch}
                                  >
                                    {lang("Buttons.apply")}
                                  </button>
                                  <span className="common-notice inline ml-4">
                              {applyNotice && lang('annotations.applyNotice')                                          }
                            </span>
                                </div>
                              </div>
                              {mrList.length > 0 && (
                                  <>
                                    <p className="record-total">
                                      {lang(
                                          "territoryDefinitionMaintenance.totalRecords"
                                      )}{" "}
                                      - {mrList.length}
                                    </p>
                                    <div
                                        ref={employeeContainerRef}
                                        className="table-responsive esearch-table hover-table"
                                    >
                                      <table
                                          className="table"
                                          aria-describedby="table"
                                      >
                                        <thead>
                                        <tr>
                                          <th scope="col">
                                            <div className="custom-checkbox d-inline-block">
                                              <input
                                                  type="checkbox"
                                                  id="tc1"
                                                  value="checkAll"
                                                  name="checkAll"
                                                  checked={allChecked}
                                                  onChange={handleCheckbox}
                                              />
                                              <label htmlFor="tc1"></label>
                                            </div>
                                          </th>
                                          <th
                                              scope="col"
                                              onClick={() =>
                                                  handleEmployeeSort(
                                                      "divisionName"
                                                  )
                                              }
                                          >
                                            <div className="cursor-pointer">
                                              {lang(
                                                  "territoryDefinitionMaintenance.division"
                                              )}{" "}
                                              <em className="bx bxs-sort-alt"></em>
                                            </div>
                                          </th>
                                          <th
                                              scope="col"
                                              onClick={() =>
                                                  handleEmployeeSort(
                                                      "branchName"
                                                  )
                                              }
                                          >
                                            <div className="cursor-pointer">
                                              {lang(
                                                  "territoryDefinitionMaintenance.branch"
                                              )}{" "}
                                              <em className="bx bxs-sort-alt"></em>
                                            </div>
                                          </th>
                                          <th
                                              scope="col"
                                              onClick={() =>
                                                  handleEmployeeSort(
                                                      "salesofficeName"
                                                  )
                                              }
                                          >
                                            <div className="cursor-pointer">
                                              {lang(
                                                  "territoryDefinitionMaintenance.salesOffice"
                                              )}
                                              <em className="bx bxs-sort-alt"></em>
                                            </div>
                                          </th>
                                          <th
                                              scope="col"
                                              onClick={() =>
                                                  handleEmployeeSort("wwid")
                                              }
                                          >
                                            <div className="cursor-pointer">
                                              {lang(
                                                  "territoryDefinitionMaintenance.wwid"
                                              )}{" "}
                                              <em className="bx bxs-sort-alt"></em>
                                            </div>
                                          </th>
                                          <th
                                              scope="col"
                                              onClick={() =>
                                                  handleEmployeeSort("mrName")
                                              }
                                          >
                                            <div className="cursor-pointer">
                                              {lang(
                                                  "parentChildFacilityMaintenance.name"
                                              )}{" "}
                                              <em className="bx bxs-sort-alt"></em>
                                            </div>
                                          </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {mrList &&
                                            Array.isArray(mrList) &&
                                            mrList.map((mr, key) => {
                                              return (
                                                  <tr key={key}>
                                                    <td>
                                                      <div className="custom-checkbox d-inline-block">
                                                        <input
                                                            type="checkbox"
                                                            id={mr.wwid}
                                                            name={mr.wwid}
                                                            value={mr.wwid}
                                                            checked={
                                                              mr.isChecked
                                                            }
                                                            onChange={
                                                              handleCheckbox
                                                            }
                                                            key={mr.wwid}
                                                        />
                                                        <label
                                                            htmlFor={mr.wwid}
                                                        ></label>
                                                      </div>
                                                    </td>
                                                    <td>{mr.divisionName}</td>
                                                    <td>{mr.branchName}</td>
                                                    <td>
                                                      {mr.salesofficeName}
                                                    </td>
                                                    <td>{mr.wwid}</td>
                                                    <td>{mr.mrName}</td>
                                                  </tr>
                                              );
                                            })}
                                        </tbody>
                                      </table>
                                    </div>
                                    <div className="mt-2 text-right">
                                      <button
                                          className="btn btn-primary"
                                          onClick={addEmployeeSearch}
                                      >
                                        {lang("Buttons.select")}
                                      </button>
                                    </div>
                                  </>
                              )}
                              {employeeDataLoading === true && (
                                  <Spinner animation="border" />
                              )}
                              {noEmployeeData && (
                                  <div className="noData">
                                    No data found
                                  </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang("OrganizationMenu.classifications")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={customerTypeList}
                                    placeholder={lang(
                                        "organizationDetails.customerType"
                                    )}
                                    onChange={handleCustomerTypeChange}
                                    allowClear={true}
                                    showSearch={
                                      customerTypeList &&
                                      customerTypeList.length > 0
                                          ? true
                                          : false
                                    }
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={ultmarcRecordList}
                                    placeholder={lang(
                                        "errorMessages.ultmarcRecordID"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      ultmarcRecordList &&
                                      ultmarcRecordList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={handleUltmarcRecordChange}
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang("PersonMenu.facilityClassifications")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={hundredBedsList}
                                    placeholder={lang(
                                        "organizationDetails.hundredBedsType"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      hundredBedsList &&
                                      hundredBedsList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={handleBedChange}
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={facilityFunctionList}
                                    placeholder={lang(
                                        "organizationDetails.facilityFunctionType"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      facilityFunctionList &&
                                      facilityFunctionList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={handleFacilityFunctionChange}
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={facilityClassList}
                                    placeholder={lang(
                                        "organizationDetails.facilityClassType"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      facilityClassList &&
                                      facilityClassList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={handleFacilityClassChange}
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang("PersonMenu.graduatedUniversity")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group">
                                <Select
                                    className="ant-select"
                                    options={universityList}
                                    placeholder={lang(
                                        "PersonMenu.graduatedUniversity"
                                    )}
                                    allowClear={true}
                                    showSearch={
                                      universityList &&
                                      universityList.length > 0
                                          ? true
                                          : false
                                    }
                                    onChange={handleUniversityChange}
                                    labelInValue
                                    optionFilterProp="label"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="horizon-form">
                        <div className="custom-3">
                          <label>
                            {lang("PersonMenu.graduatedYear")}
                          </label>
                        </div>
                        <div className="custom-9">
                          <div className="row">
                            <div className="col-lg-4 col-md-6">
                              <div className="form-group">
                                <label>{lang("PersonMenu.from")}</label>
                                <DatePicker
                                    // placeholder={graduatedYearFrom}
                                    selected={graduatedYearFromDate}
                                    className="form-control"
                                    onChange={(date) =>
                                        handleGraduatedYearFrom(date)
                                    }
                                    showYearPicker
                                    dateFormat="yyyy"
                                    yearItemNumber={9}
                                    isClearable
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                              <div className="form-group">
                                <label>{lang("PersonMenu.to")}</label>
                                <DatePicker
                                    selected={graduatedYearToDate}
                                    className="form-control"
                                    onChange={(date) =>
                                        handleGraduatedYearTo(date)
                                    }
                                    showYearPicker
                                    dateFormat="yyyy"
                                    yearItemNumber={9}
                                    isClearable
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="horizon-form">
                      <div className="custom-3">
                        <label>{lang("PersonMenu.sortOrder")}</label>
                      </div>
                      <div className="custom-9 mt-2">
                        <div className="custom-radio d-inline-block">
                          <input
                            type="radio"
                            id="order1"
                            name="sort-order"
                            value="UnifiedCustomerCode"
                            defaultChecked
                            onChange={(e) => handleSortOrder(e)}
                          />
                          <label htmlFor="order1">
                            {lang("OrganizationMenu.byIntegratedCode")}
                          </label>
                        </div>
                        <div className="custom-radio d-inline-block">
                          <input
                            type="radio"
                            id="order2"
                            name="sort-order"
                            value="CustomerNameLocal"
                            onChange={(e) => handleSortOrder(e)}
                          />
                          <label htmlFor="order2">
                            {lang("OrganizationMenu.byName")}
                          </label>
                        </div>
                      </div>
                    </div> */}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
                <div className="steps-action1 mt-4">
                  {isLoading && <Spinner animation="border" />}
                  <button
                      className="btn btn-primary"
                      onClick={handlePersonSearch}
                      disabled={isLoading}
                  >
                    {lang("Buttons.search")}
                  </button>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>


          {personList && personList.length < 1 && loading === true && (
            <Spinner animation="border" />
          )}
          {noData && (
            <div className="noData">{lang("errorMessages.NO_DATA")}</div>
          )}
          {personList.length > 0 && loading === false && (
            <>
              <p className="record-total">
                {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                {personList.length} / {total}
              </p>
            </>
          )}
          {personList.length > 0 && (
            <>
              <div
                // ref={containerRef}
                className="table-responsive mb-0 hover-table max-height person-result"
                // onScroll={onScroll}
              >
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            /* column: "legacyUnifiedCustomerCode",   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            column: "unifiedCustomerCode",            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                            sortOrder: sortCode === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("parentChildFacilityMaintenance.code")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerNameLocal",
                            sortOrder:
                              sortKanjiName === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("PersonMenu.kanjiName")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerNameLocalKana",
                            sortOrder: sortKanaName === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("PersonMenu.kanaName")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                      >
                        <div className="cursor-pointer">
                          {lang("PersonMenu.gender")}{" "}
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "customerTypeNameLocal",
                            sortOrder:
                              sortCustomerType === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("OrganizationMenu.customerType")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "universityNameLocal",
                            sortOrder:
                              sortGraduatedUniversity === "desc"
                                ? "asc"
                                : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("PersonMenu.graduatedUniversity")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                        onClick={() =>
                          handleSortingData({
                            column: "graduatedYear",
                            sortOrder:
                              sortGraduatedYear === "desc" ? "asc" : "desc",
                          })
                        }
                      >
                        <div className="cursor-pointer">
                          {lang("PersonMenu.graduatedYear")}{" "}
                          <em className="bx bxs-sort-alt"></em>
                        </div>
                      </th>
                      <th
                        scope="col"
                      >
                        <div className="cursor-pointer">
                          {lang("personDetails.affiliatedFacilities")}{" "}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {personList.length > 0 &&
                      personList.map((per) => {
                        return (
                          per && (
                            <tr
                              key={per.perCustID}
                              onClick={() => handlePersonDetails(per.perCustID)}
                            >
                              <td>
                                {/* per && per.legacyUnifiedCustomerCode  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                 /* ? per.legacyUnifiedCustomerCode       /* SAKAMOTO: AHDD-5861 Ultmarc code change */ }
                                {per && per.unifiedCustomerCode           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  ? per.unifiedCustomerCode               /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  : ""}
                              </td>
                              <td>
                                {per && per.customerNameLocal
                                  ? per.customerNameLocal
                                  : ""}
                              </td>
                              <td>
                                {per && per.customerNameLocalKana
                                  ? per.customerNameLocalKana
                                  : ""}
                              </td>
                              <td>
                                {per && per.genderNameLocal
                                  ? per.genderNameLocal
                                  : ""}
                              </td>
                              <td>
                                {per && per.customerTypeNameLocal
                                  ? per.customerTypeNameLocal
                                  : ""}
                              </td>
                              <td>
                                {per && per.universityNameLocal
                                  ? per.universityNameLocal
                                  : ""}
                              </td>
                              <td>
                                {per && per.graduatedYear
                                  ? per.graduatedYear
                                  : ""}
                              </td>
                              <td>
                                {per && per.affiliatedFacilities
                                    ? per.affiliatedFacilities
                                    : ""}
                              </td>
                            </tr>
                            //  <tr>
                            //   <td colSpan={7}>LOADING</td>
                            //  </tr>
                          )
                        );
                      })}
                  </tbody>
                </table>
              </div>
              {personList.length < total && <div className="steps-action1 mt-4">
                {lazyLoading && <Spinner animation="border" />}
                <button className="btn btn-primary" onClick={loadRecords} disabled={lazyLoading}>
                  {lang("Buttons.loadMore")}
                </button>
              </div>}
            </>
          )}
        </>
      )}
    </Home>
  );
}

export default PersonCustomer;
